import { Component, Input } from '@angular/core';
import { ClienteService } from 'app/services/cliente.service';
import { Global } from 'app/@core/lib/global';
import { AuthService } from 'app/services/auth.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-companies',
  templateUrl: './dashboard-companies.component.html',
  providers: [ClienteService, TranslateService]
})

export class DashboardCompaniesComponent {

  public companies;
  public user;

  constructor(
    public authService: AuthService,
    public clienteService: ClienteService,
    public global: Global,
    public router: Router
  ) {
    this.user = this.global.loggedUser();
    if ((this.user) && (this.user.admin)) {
      this.clienteService.getGroup(this.user.client_id).subscribe((response) => {
        if (response.data.length > 0) {
          let companies = response.data;
          let c = companies.find(c => c.id == this.user.client_id);
          if ((c.company_id == null) || (c.company_id == this.user.client_id)) {
            this.companies = companies;
            this.global.companies = response.data;
            sessionStorage.setItem("companies", JSON.stringify(this.companies));
          }
        }
        else {
          let companies = sessionStorage.getItem("companies");
          if (companies) {
            this.companies = JSON.parse(companies);
            this.global.companies = this.companies;
          }
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/companies/dashboard-companies.component.ts